export class KontraktDrivningspunkterValidationTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        header: "Drivningspunkter",
        avlagg: "Minst ett avlägg. Alla avlägg ska ha tillgänglighetsklass",
        kojplats: "Minst en kojplats",
        larmkoordinat: "Endast en larmkoordinat"
    };
}
